import React, { useMemo, useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { CardActionType, type CardActionItem } from './index.type'
import { Toast } from 'react-vant'
import { useUserInfo } from '@/hooks'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import Ripple from '@/components/Ripple'

export default React.memo(function Safety() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { userInfo } = useUserInfo()

    const cardActionItems = useMemo<CardActionItem[]>(
        () => ([
            {
                icon: "/icon/phone-icon.svg",
                title: t('手机号'),
                actionType: CardActionType.Phone
            },
            {
                icon: "/icon/email-icon.svg",
                title: t('邮箱'),
                actionType: CardActionType.Email
            },
            {
                icon: "/icon/google-ver-icon.svg",
                title: t('谷歌验证器'),
                actionType: CardActionType.Google
            }
        ]),
        [t]
    )
    const handleCardAction = useCallback((_actionType: CardActionType) => {

        if (_actionType === CardActionType.Phone) {
            if (userInfo?.phone) {
                navigate('/safety/change-account', { state: { changeType: CardActionType.Phone } })
            } else {
                navigate('/safety/bind-phone')
            }
        } else if (_actionType === CardActionType.Email) {
            if (userInfo?.email) {
                navigate('/safety/change-account', { state: { changeType: CardActionType.Email } })
            } else {
                navigate('/safety/bind-email')
            }
        } else if (_actionType === CardActionType.Google) {
            // 检查是否已绑定谷歌验证器
            if (userInfo?.is_bind_google) {
                navigate('/safety/change-account', { state: { changeType: CardActionType.Google } })
            } else {
                navigate('/safety/bind-google')
            }
        }
    }, [navigate, userInfo?.is_bind_google])


    return (
        <PageLayout tabbarPage={true}>
            <Header
                leftChildren={<Back />}
                centerChildren={<div className="text-3.75 font-medium text-black">{t('安全中心')}</div>}
            />
            <div className="px-6 py-6">
                <div className="w-full flex flex-col items-center space-y-5">
                    {cardActionItems.map(item => (
                        <Ripple key={item.title} className="rounded-3xl w-full">
                            <div
                                key={item.title}
                                className="w-full flex h-17 justify-between items-center border-[0.5px] border-solid border-[#E5E5E5] rounded-3xl px-5 cursor-pointer"
                                onClick={() => handleCardAction(item.actionType)}
                            >
                                <div className="flex items-center">
                                    <div className="w-8 h-8 rounded-full flex items-center justify-center mr-1">
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <div className="flex flex-col">
                                        <div className="text-base font-500 text-black">{item.title}</div>
                                    </div>
                                </div>
                                <div><img src="/icon/right-info.svg" /></div>
                            </div>
                        </Ripple>
                    ))}
                </div>
            </div>
        </PageLayout>
    )
})